import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=55726b3a&scoped=true&"
import script from "./Group.vue?vue&type=script&lang=js&"
export * from "./Group.vue?vue&type=script&lang=js&"
import style1 from "./Group.vue?vue&type=style&index=1&id=55726b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55726b3a",
  null
  
)

export default component.exports